var map = {
	"./alchemy.jpg": 8439,
	"./blacksmithing.jpg": 1468,
	"./cooking.jpg": 4938,
	"./enchanting.jpg": 5417,
	"./engineering.jpg": 3467,
	"./first_aid.jpg": 6935,
	"./fishing.jpg": 792,
	"./herbalism.jpg": 917,
	"./inscription.jpg": 4928,
	"./jewelcrafting.jpg": 8533,
	"./leatherworking.jpg": 160,
	"./mining.jpg": 8652,
	"./skinning.jpg": 3049,
	"./tailoring.jpg": 3609
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6854;